export default __webpack_public_path__ + "static/media/Equipment.5d07f886.svg";